import { InfoCircleOutlined } from "@ant-design/icons";
import { Surgeon } from "../../../../types/surgeons";
import { uploadedImagePath } from "../../../../utils/uploadedImage";
import { formatCurrency } from "../../../../utils/currencyFormatter";
//import Meta from "antd/es/card/Meta";

type SurgeonCardProps = {
  surgeon: Surgeon;
  isSelected: boolean;
  isDisabled: boolean;
  imageUrl?: string;
  imageOnly?: boolean;
  minPrice: number;
  quoteData: any;
};

const SurgeonMobileListItem = ({
  surgeon,
  isDisabled,
  isSelected,
  imageUrl,
  imageOnly,
  minPrice,
  quoteData,
}: SurgeonCardProps) => {
  return (
    <>
      <div
        key={surgeon.id}
        className={`surgeon-mobile-list-item ${isSelected ? "selected" : ""} ${
          isDisabled ? "disabled" : ""
        }`}
        onClick={() => {
          if (isDisabled) {
            return;
          }
        }}
      >
        <span className="surgeon-item-mobile-image">
          <img
            style={{
              objectFit: "cover",
              height: "75px",
              width: "75px",
              borderRadius: "8px",
            }}
            src={
              imageUrl
                ? uploadedImagePath(imageUrl)
                : `${process.env.PUBLIC_URL}/img/app-logo.png`
            }
            loading="lazy"
            decoding="async"
          ></img>
        </span>

        <span className="surgeon-name-mobile">
          <span className="surgeon-name-mobile-content">
            {surgeon.name} ({surgeon.nickname})
          </span>

          {!imageOnly && (
            <div style={{ paddingTop: "5px" }}>
              {isDisabled ? (
                "--"
              ) : (
                <div>
                  {quoteData.selectedSurgeon && (
                    <div>{/* From: <b>{formatCurrency(minPrice)}</b> */}</div>
                  )}
                </div>
              )}
            </div>
          )}
        </span>

        <span className="selected-indicator"></span>
      </div>
    </>
  );
};

export default SurgeonMobileListItem;
